/**
 * Club join gate: members must acknowledge current rules before other tabs.
 * Presidents are never gated. Unknown ack (null/undefined) does not lock.
 */

export function isClubJoinGateActive({ isPresident = false, acknowledged } = {}) {
  if (isPresident) return false;
  if (acknowledged === true) return false;
  if (acknowledged === false) return true;
  return false;
}

/**
 * Path for rules under join gate. Preserves join=1 when present.
 */
export function clubJoinGateRulesPath(clubId, { joinMode = false } = {}) {
  const base = `/clubs/${clubId}/rules`;
  return joinMode ? `${base}?join=1` : base;
}

/**
 * True when pathname is the club Rules surface (not other club routes).
 */
export function isClubRulesPath(pathname = '') {
  return /\/clubs\/[^/]+\/rules\/?$/.test(String(pathname));
}
